/**
 * Layout: Content - Shapes
 * Slug: content_shapes
 */

document.addEventListener('DOMContentLoaded', function() {
    const layouts = document.querySelectorAll('.flex-layout.content_shapes-layout');

	layouts.forEach((layout) => {
		
	});
});
